module.exports = __webpack_public_path__ + "static/media/pic3.a7f6b221.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic3.png
// module id = 232
// module chunks = 0